import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
} from "reactstrap";
import { Formik, Field, Form } from "formik";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "react-modern-calendar-datepicker";
import jMoment from "moment-jalaali";

import IntlMessages from "../../../../../../helpers/IntlMessages";

import { ProductPricing } from "../../../../../../api/Api";
export default class EditConstant extends Component {
  state = {
    loading: false,
    isActive: true,
  };

  setDate = (e) => {
    let date =
      e.year.toString() + "/" + e.month.toString() + "/" + e.day.toString();
    // let miladiDate = jMoment(date).format("YYYY/M/D");
    let miladiDate = jMoment(date, "jYYYY/jM/jD").format("YYYY-M-D");

    this.setState({
      date: e,
      dateSent: miladiDate,
    });
  };

  componentDidMount() {}

  handleSubmit = async (values, { resetForm, setSubmitting, setValues }) => {
    this.setState({ loading: true });
    // console.log(this.props);
    try {
      let newValues = {
        ...values,
        date: this.state.dateSent,

        productId: this.props.product.id,
      };

      await ProductPricing.addProductPricing(newValues);

      //closing addNew Component
      this.props.toggleModal();

      //fetching data from dataBase
      this.props.dataListRender();

      // if (!this.state.isNew) {
      //   Swal.close();
      // }
      resetForm();
    } catch (error) {
      console.error(error);
      // toast(error.response.data.message);
    }
    this.setState({ loading: false });
  };

  handleChangeIsActive = (e) => {
    this.setState({
      isActive: e.target.value,
    });
  };

  render() {
    return (
      <>
        <Modal
          isOpen={this.props.modalOpen}
          toggle={this.props.toggleModal}
          wrapClassName="modal-right"
          backdrop="static"
        >
          {this.state.loading ? <div className="loading" /> : ""}
          <ModalHeader toggle={this.props.toggleModal}>
            <IntlMessages id="pages.add-new-modal-title" />
          </ModalHeader>
          <ModalBody>
            <Formik
              initialValues={this.state.initialValues}
              // validationSchema={this.ValidationSchema}
              onSubmit={this.handleSubmit}
            >
              {(props) => (
                <Form className="form" onSubmitCapture={props.handleSubmit}>
                  <Label className="mt-4">
                    <IntlMessages id="قیمت" />
                  </Label>
                  <Field
                    name="price"
                    placeholder="مبلغ  "
                    className="form-control"
                    type="number"
                    required
                  />
                  <Label className="mt-4">
                    <IntlMessages id="تاریخ" />
                  </Label>
                  <DatePicker
                    style={{ innerWidth: "100%", margin: "20px 20px 0px 0px" }}
                    position="bottom"
                    value={this.state.date}
                    name="date"
                    onChange={this.setDate}
                    // inputPlaceholder={this.state.initialValues.date}
                    shouldHighlightWeekends
                    locale="fa" // add this
                    inputName="date"
                  />

                  <ModalFooter>
                    <Button
                      color="secondary"
                      outline
                      onClick={this.props.toggleModal}
                    >
                      <IntlMessages id="pages.cancel" />
                    </Button>
                    <Button color="primary" type="submit">
                      <IntlMessages id="pages.submit" />
                    </Button>{" "}
                  </ModalFooter>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </Modal>
      </>
    );
  }
}
